// The one place that builds a toast.
//
// This markup was hand-rolled in three table controllers at once
// (table_interactions, table_saved_views, table_navigation) and had already
// drifted: the navigation copy put `.toast-header__content` on a <span> where
// the others wrap a <span> in a <div>, and hardcoded the `error` icon. The
// shape below is the superset — the only one of the three that could render an
// action link — so every caller keeps what it had.
//
// `#toast_container` is rendered by layouts/application.html.erb. A missing
// container is not an error: a toast is an aside, and a page that has none has
// nothing to say it in.
const ICONS = { success: "check_circle", error: "error", warning: "warning", info: "info" }
const COLORS = {
  success: "text-success",
  error: "text-danger",
  warning: "text-warning",
  info: "text-info"
}

// `action_url` / `action_label` are the server's spelling: a bulk action's JSON
// reply is handed to this function as-is, so both cases have to be accepted
// rather than the caller remembering to translate them.
export function showToast({
  type = "info",
  message,
  actionUrl,
  actionLabel,
  action_url: actionUrlFromServer,
  action_label: actionLabelFromServer,
  closeLabel = "Close"
}) {
  if (!message) return

  const url = actionUrl || actionUrlFromServer
  const label = actionLabel || actionLabelFromServer

  const container = document.getElementById("toast_container")
  if (!container) return

  const toast = document.createElement("div")
  toast.className = "toast"
  toast.setAttribute("role", "alert")
  toast.setAttribute("aria-live", "assertive")
  toast.setAttribute("aria-atomic", "true")
  toast.dataset.controller = "toast"

  const header = document.createElement("div")
  header.className = "toast-header text-white"

  const icon = document.createElement("span")
  icon.className = `material-symbols-outlined ${COLORS[type] || COLORS.info}`
  icon.setAttribute("aria-hidden", "true")
  icon.textContent = ICONS[type] || ICONS.info

  const title = document.createElement("div")
  title.className = "toast-header__content me-auto"

  const messageText = document.createElement("span")
  messageText.textContent = message
  title.appendChild(messageText)

  if (url && label) {
    title.appendChild(document.createTextNode(" "))

    const link = document.createElement("a")
    link.href = url
    link.className = "toast-header__action"
    link.textContent = label

    title.appendChild(link)
  }

  const closeButton = document.createElement("button")
  closeButton.type = "button"
  closeButton.className = "btn-close btn-close-white"
  closeButton.setAttribute("data-bs-dismiss", "toast")
  closeButton.setAttribute("aria-label", closeLabel)

  header.append(icon, title, closeButton)
  toast.appendChild(header)

  container.appendChild(toast)
}

// A toast that has to survive the navigation that earned it — a saved view
// applied, a bulk action that reloads the list. Both halves swallow storage
// failures: a toast lost to private mode is not worth an exception.
export function queueToast(storageKey, toast) {
  if (!toast?.message) return

  try {
    window.sessionStorage.setItem(storageKey, JSON.stringify(toast))
  } catch (_error) {
    // Nothing to show after the navigation; the action itself still happened.
  }
}

export function consumeToast(storageKey) {
  try {
    const pending = window.sessionStorage.getItem(storageKey)
    if (!pending) return

    window.sessionStorage.removeItem(storageKey)
    showToast(JSON.parse(pending))
  } catch (_error) {
    // Unreadable storage or an invalid payload — there is nothing to say.
  }
}
